export const DAMAGE_GAG_TRACKS = new Set(['Sound', 'Throw', 'Squirt', 'Drop']);

export const GAG_TRACKS = [
  {
    name: 'Toon-Up',
    accuracy: 70,
    gags: [
      {
        name: 'Feather',
        file: 'feather.png',
        min: 8,
        max: 10,
        organicMin: 10,
        organicMax: 12,
        kind: 'heal',
      },
      {
        name: 'Megaphone',
        file: 'megaphone.png',
        targeting: 'all-toons-except-self',
        min: 15,
        max: 18,
        organicMin: 18,
        organicMax: 22,
        kind: 'heal',
      },
      {
        name: 'Lipstick',
        file: 'lipstick.png',
        min: 25,
        max: 30,
        organicMin: 30,
        organicMax: 36,
        kind: 'heal',
      },
      {
        name: 'Bamboo Cane',
        file: 'bamboo_cane.png',
        targeting: 'all-toons-except-self',
        min: 40,
        max: 45,
        organicMin: 48,
        organicMax: 54,
        kind: 'heal',
      },
      {
        name: 'Pixie Dust',
        file: 'pixie_dust.png',
        min: 50,
        max: 60,
        organicMin: 60,
        organicMax: 72,
        kind: 'heal',
      },
      {
        name: 'Juggling Cubes',
        file: 'juggling_cubes.png',
        targeting: 'all-toons-except-self',
        min: 75,
        max: 105,
        organicMin: 90,
        organicMax: 126,
        kind: 'heal',
      },
      {
        name: 'High Dive',
        file: 'high_dive.png',
        targeting: 'all-toons-except-self',
        min: 210,
        max: 210,
        organicMin: 252,
        organicMax: 252,
        kind: 'heal',
      },
    ],
  },
  {
    name: 'Trap',
    accuracy: 100,
    gags: [
      {
        name: 'Banana Peel',
        file: 'banana_peel.png',
        min: 10,
        max: 12,
        organicMin: 11,
        organicMax: 14,
        kind: 'damage',
      },
      {
        name: 'Rake',
        file: 'rake.png',
        min: 18,
        max: 20,
        organicMin: 20,
        organicMax: 22,
        kind: 'damage',
      },
      {
        name: 'Marbles',
        file: 'marbles.png',
        min: 30,
        max: 35,
        organicMin: 33,
        organicMax: 39,
        kind: 'damage',
      },
      {
        name: 'Quicksand',
        file: 'quicksand.png',
        min: 45,
        max: 50,
        organicMin: 50,
        organicMax: 55,
        kind: 'damage',
      },
      {
        name: 'Trapdoor',
        file: 'trapdoor.png',
        min: 75,
        max: 85,
        organicMin: 84,
        organicMax: 94,
        kind: 'damage',
      },
      {
        name: 'TNT',
        file: 'tnt.png',
        min: 90,
        max: 180,
        organicMin: 99,
        organicMax: 198,
        kind: 'damage',
      },
      {
        name: 'Railroad',
        file: 'railroad.png',
        targeting: 'all-cogs',
        min: 200,
        max: 200,
        organicMin: 220,
        organicMax: 220,
        kind: 'damage',
      },
    ],
  },
  {
    name: 'Lure',
    organicAccuracyBonus: 10,
    gags: [
      { name: '1 Bill', file: '1_bill.png', accuracy: 60, roundsLured: 3 },
      {
        name: 'Small Magnet',
        file: 'small_magnet.png',
        targeting: 'all-cogs',
        accuracy: 55,
        roundsLured: 3,
      },
      { name: '5 Bill', file: '5_bill.png', accuracy: 70, roundsLured: 4 },
      {
        name: 'Big Magnet',
        file: 'big_magnet.png',
        targeting: 'all-cogs',
        accuracy: 65,
        roundsLured: 4,
      },
      { name: '10 Bill', file: '10_bill.png', accuracy: 80, roundsLured: 5 },
      {
        name: 'Hypno Goggles',
        file: 'hypno_goggles.png',
        targeting: 'all-cogs',
        accuracy: 75,
        roundsLured: 5,
      },
      {
        name: 'Presentation',
        file: 'presentation.png',
        targeting: 'all-cogs',
        accuracy: 90,
        roundsLured: 8,
      },
    ],
  },
  {
    name: 'Sound',
    accuracy: 95,
    gags: [
      {
        name: 'Bike Horn',
        file: 'bike_horn.png',
        targeting: 'all-cogs',
        min: 3,
        max: 4,
        organicMin: 4,
        organicMax: 5,
        kind: 'damage',
      },
      {
        name: 'Whistle',
        file: 'whistle.png',
        targeting: 'all-cogs',
        min: 5,
        max: 7,
        organicMin: 6,
        organicMax: 8,
        kind: 'damage',
      },
      {
        name: 'Bugle',
        file: 'bugle.png',
        targeting: 'all-cogs',
        min: 9,
        max: 11,
        organicMin: 10,
        organicMax: 13,
        kind: 'damage',
      },
      {
        name: 'Aoogah',
        file: 'aoogah.png',
        targeting: 'all-cogs',
        min: 14,
        max: 16,
        organicMin: 16,
        organicMax: 18,
        kind: 'damage',
      },
      {
        name: 'Elephant Trunk',
        file: 'elephant_trunk.png',
        targeting: 'all-cogs',
        min: 19,
        max: 21,
        organicMin: 21,
        organicMax: 24,
        kind: 'damage',
      },
      {
        name: 'Foghorn',
        file: 'foghorn.png',
        targeting: 'all-cogs',
        min: 25,
        max: 50,
        organicMin: 28,
        organicMax: 55,
        kind: 'damage',
      },
      {
        name: 'Opera Singer',
        file: 'opera_singer.png',
        targeting: 'all-cogs',
        min: 90,
        max: 90,
        organicMin: 99,
        organicMax: 99,
        kind: 'damage',
      },
    ],
  },
  {
    name: 'Throw',
    accuracy: 75,
    gags: [
      {
        name: 'Cupcake',
        file: 'cupcake.png',
        min: 4,
        max: 6,
        organicMin: 5,
        organicMax: 7,
        kind: 'damage',
      },
      {
        name: 'Fruit Pie Slice',
        file: 'fruit_pie_slice.png',
        min: 8,
        max: 10,
        organicMin: 9,
        organicMax: 11,
        kind: 'damage',
      },
      {
        name: 'Cream Pie Slice',
        file: 'cream_pie_slice.png',
        min: 14,
        max: 17,
        organicMin: 16,
        organicMax: 19,
        kind: 'damage',
      },
      {
        name: 'Whole Fruit Pie',
        file: 'whole_fruit_pie.png',
        min: 24,
        max: 27,
        organicMin: 27,
        organicMax: 30,
        kind: 'damage',
      },
      {
        name: 'Whole Cream Pie',
        file: 'whole_cream_pie.png',
        min: 36,
        max: 40,
        organicMin: 40,
        organicMax: 44,
        kind: 'damage',
      },
      {
        name: 'Birthday Cake',
        file: 'birthday_cake.png',
        min: 48,
        max: 100,
        organicMin: 53,
        organicMax: 110,
        kind: 'damage',
      },
      {
        name: 'Wedding Cake',
        file: 'wedding_cake.png',
        targeting: 'all-cogs',
        min: 120,
        max: 120,
        organicMin: 132,
        organicMax: 132,
        kind: 'damage',
      },
    ],
  },
  {
    name: 'Squirt',
    accuracy: 95,
    gags: [
      {
        name: 'Squirting Flower',
        file: 'squirting_flower.png',
        min: 3,
        max: 4,
        organicMin: 4,
        organicMax: 5,
        kind: 'damage',
      },
      {
        name: 'Glass of Water',
        file: 'glass_of_water.png',
        min: 6,
        max: 8,
        organicMin: 7,
        organicMax: 10,
        kind: 'damage',
      },
      {
        name: 'Squirt Gun',
        file: 'squirt_gun.png',
        min: 10,
        max: 12,
        organicMin: 12,
        organicMax: 14,
        kind: 'damage',
      },
      {
        name: 'Seltzer Bottle',
        file: 'seltzer_bottle.png',
        min: 18,
        max: 21,
        organicMin: 22,
        organicMax: 25,
        kind: 'damage',
      },
      {
        name: 'Fire Hose',
        file: 'fire_hose.png',
        min: 27,
        max: 30,
        organicMin: 32,
        organicMax: 35,
        kind: 'damage',
      },
      {
        name: 'Storm Cloud',
        file: 'storm_cloud.png',
        min: 36,
        max: 80,
        organicMin: 42,
        organicMax: 92,
        kind: 'damage',
      },
      {
        name: 'Geyser',
        file: 'geyser.png',
        targeting: 'all-cogs',
        min: 105,
        max: 105,
        organicMin: 121,
        organicMax: 121,
        kind: 'damage',
      },
    ],
  },
  {
    name: 'Drop',
    accuracy: 50,
    gags: [
      {
        name: 'Flower Pot',
        file: 'flower_pot.png',
        min: 10,
        max: 10,
        organicMin: 12,
        organicMax: 12,
        kind: 'damage',
      },
      {
        name: 'Sandbag',
        file: 'sandbag.png',
        min: 18,
        max: 18,
        organicMin: 21,
        organicMax: 21,
        kind: 'damage',
      },
      {
        name: 'Anvil',
        file: 'anvil.png',
        min: 30,
        max: 30,
        organicMin: 35,
        organicMax: 35,
        kind: 'damage',
      },
      {
        name: 'Big Weight',
        file: 'big_weight.png',
        min: 45,
        max: 45,
        organicMin: 52,
        organicMax: 52,
        kind: 'damage',
      },
      {
        name: 'Safe',
        file: 'safe.png',
        min: 60,
        max: 70,
        organicMin: 69,
        organicMax: 81,
        kind: 'damage',
      },
      {
        name: 'Grand Piano',
        file: 'grand_piano.png',
        min: 85,
        max: 170,
        organicMin: 98,
        organicMax: 196,
        kind: 'damage',
      },
      {
        name: 'Toontanic',
        file: 'toontanic.png',
        targeting: 'all-cogs',
        min: 180,
        max: 180,
        organicMin: 207,
        organicMax: 207,
        kind: 'damage',
      },
    ],
  },
];
